import { render, staticRenderFns } from "./parcel_move_more.vue?vue&type=template&id=2f870a6e&"
import script from "./parcel_move_more.vue?vue&type=script&lang=js&"
export * from "./parcel_move_more.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports